import {IconButton, Menu, Typography} from '@mui/material'
import {styled} from '@mui/material/styles'
import theme from '../../../themes/index'
import LogoutIcon from '@mui/icons-material/Logout'
import {StyledTitle} from '../../Campaigns/AskGivePrism/Styles'

export const StyledProfileIcon = styled(IconButton)(() => ({
  height: '40px',
  width: '40px',
  color: theme.palette.common.black,
  backgroundColor: theme.palette.common.lightGrey,
  '&:hover': {
    backgroundColor: theme.palette.common.lightGrey
  }
}))

export const StyledProfileCircleTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.heading.fontSize.xxs,
  float: 'right',
  padding: '6px'
}))

export const StyledMenu = styled(Menu)(({theme}) => ({
  '& .MuiPaper-root': {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  '& .MuiMenu-list': {
    padding: '4px'
  }
}))

export const StyledLogoutIcon = styled(LogoutIcon)(({theme}) => ({
  height: '16px',
  margin: 0
}))

export const StyledSpan = styled('span')(({theme}) => ({
  fontSize: theme.typography.heading.fontSize.xs
}))

export const StyledDiv = styled('div')(({theme}) => ({
  padding: '10px'
}))

export const StyledTitleContainer = styled(StyledTitle)(({theme}) => ({
  color: theme.palette.common.black,
  fontSize: theme.typography.heading.fontSize.l
}))
